<section class="category-section">
  <div class="sidebar">
    <h3>Categories</h3>

    <ul class="categories-link" #categoryList>
      <li>
        <a
          [routerLink]="['/help-center/all']"
          routerLinkActive="active"
          (click)="
            redirectToHelpCenter(); showAllCategories(); toggleClosedAccordion()
          "
          >
          All
        </a>
      </li>

      @if (allContentCategories$) {
        @for (category of allContentCategories$; track category) {
          <li>
            <a
              [routerLink]="['/help-center/' + category.code]"
              class="categoryLinks"
              (click)="toggleClosedAccordion()"
              [class.active]="setActiveLeftCategory(category)"
            >
              {{ category?.name }}
            </a>
          </li>
        }
      }
    </ul>
    <app-custom-most-popular-component></app-custom-most-popular-component>
  </div>
  <div class="category-content position-relative">
    <div>
      @if (!allContentCategories$ ) {
        <mat-spinner class="spinner absolute top200" mode="indeterminate" diameter="100"></mat-spinner>
      }
      @if (selectedCategory) {
        <div>
          <a
            href="javascript:void(0);"
            (click)="toggleAllAccordion()"
            class="expandAllAccordion"
            >+/- All</a
            >
            <h2 class="category-name">{{ selectedCategory.name }}</h2>
            <div class="accordions">
              @for (item of selectedCategory.contentItems; track item; let i = $index) {
                <div
                  class="accordion"
            [ngClass]="{
              selected: item.selected
            }"
                  >
                  <div class="accordion-header" (click)="toggleAccordion(item)">
                    <h3 class="accordion-title">{{ item.title }}</h3>
                    <span class="accordion-icon">{{
                      item.selected ? "-" : "+"
                    }}</span>
                  </div>
                  @if (item.selected) {
                    <div class="accordion-content">
                      <div class="content-data" [innerHTML]="item.content"></div>
                      @for (item of item.contentDocuments; track item; let i = $index) {
                        <div>
                          <div>
                            @if (item.type == 'PAGE_LINK') {
                              <a
                                href="{{ item.url }}"
                                target="_blank"
                                class="linkText"
                                >{{ item.linkText }}</a
                                >
                              }
                            </div>
                          </div>
                        }
                        @if (showHeading(item?.contentDocuments)) {
                          <h1>
                            <p class="resources-text">Resources</p>
                          </h1>
                        }
                        @for (item of item.contentDocuments; track item; let i = $index) {
                          <div>
                            @if (item.type == 'YOUTUBE_VIDEO' || item.type == 'VIDEO') {
                              <p
                                class="resources-text"
                                >
                                {{ item.linkText }}
                              </p>
                            }
                            <div>
                              @if (item.type == 'PDF') {
                                <div
                                  class="document-info d-flex flex-wrap justify-content-between"
                                  >
                                  @if (item.type == 'PDF') {
                                    <a
                                      href="{{ item.url }}"
                                      target="_blank"
                                      class="linkText"
                                      >{{ item.linkText }}</a
                                      >
                                    }
                                    <a href="{{ item.url }}" class="viewAllText" target="_blank"
                                      >View
                                      <img
                                        src="/icons/viewIconNew.svg"
                                        width="15"
                                        height="20"
                                      /></a>
                                    </div>
                                  }
                                </div>
                                @if (item.type == 'YOUTUBE_VIDEO') {
                                  <div class="youtube_video">
                                    <iframe
                                      width="345"
                                      class="iframe-youtube"
                                      allowfullscreen=""
                                      height="194"
                                      [attr.src]="item?.url | safe : 'resourceUrl'"
                                      >
                                  </iframe>
                                </div>
                              }
                              @if (item.type == 'VIDEO') {
                                <div class="youtube_video">
                                  <iframe
                                    width="345"
                                    class="iframe-youtube"
                                    allowfullscreen=""
                                    height="194"
                                    [attr.src]="item?.url | safe : 'resourceUrl'"
                                    >
                                  </iframe>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>
          @if (!selectedCategory) {
            <div>
              <a
                href="javascript:void(0);"
                (click)="toggleAllAccordion()"
                class="expandAllAccordion"
                >+/- All</a
                >
                @if (filteredContents$) {
                  <div>
                    @for (category of filteredContents$; track category) {
                      <div>
                        <h2 class="category-name">{{ category?.name }}</h2>
                        <div class="accordions">
                          @for (item of category?.contentItems; track item; let i = $index) {
                            <div
                              class="accordion"
                              [ngClass]="{ selected: item.selected }"
                              >
                              <div class="accordion-header" (click)="toggleAccordion(item)">
                                <h3 class="accordion-title">{{ item.title }}</h3>
                                <span class="accordion-icon">{{
                                  item.selected ? "-" : "+"
                                }}</span>
                              </div>
                              @if (item.selected) {
                                <div class="accordion-content">
                                  <div class="content-data" [innerHTML]="item.content"></div>
                                  @for (item of item.contentDocuments; track item; let i = $index) {
                                    <div>
                                      <div>
                                        @if (item.type == 'PAGE_LINK') {
                                          <a
                                            href="{{ item.url }}"
                                            target="_blank"
                                            class="linkText"
                                            >{{ item.linkText }}</a
                                            >
                                          }
                                        </div>
                                      </div>
                                    }
                                    @if (showHeading(item?.contentDocuments)) {
                                      <h1>
                                        <p class="resources-text">Resources</p>
                                      </h1>
                                    }
                                    @for (item of item.contentDocuments; track item; let i = $index) {
                                      <div>
                                        @if (item.type == 'YOUTUBE_VIDEO' || item.type == 'VIDEO') {
                                          <p
                                            class="resources-text"
                                            >
                                            {{ item.linkText }}
                                          </p>
                                        }
                                        <div>
                                          @if (item.type == 'PDF') {
                                            <div
                                              class="document-info d-flex flex-wrap justify-content-between"
                                              >
                                              @if (item.type == 'PDF') {
                                                <a
                                                  href="{{ item.url }}"
                                                  target="_blank"
                                                  class="linkText"
                                                  >{{ item.linkText }}</a
                                                  >
                                                }
                                                <a
                                                  href="{{ item.url }}"
                                                  class="viewAllText"
                                                  target="_blank"
                                                  >View
                                                  <img
                                                    src="/icons/viewIconNew.svg"
                                                    width="15"
                                                    height="20"
                                                  /></a>
                                                </div>
                                              }
                                            </div>
                                            @if (item.type == 'YOUTUBE_VIDEO') {
                                              <div
                                                class="youtube_video"
                                                >
                                              <iframe
                                                width="345"
                                                class="iframe-youtube"
                                                allowfullscreen=""
                                                height="194"
                                                [attr.src]="item?.url | safe : 'resourceUrl'"
                                                >
                                              </iframe>
                                            </div>
                                          }
                                          @if (item.type == 'VIDEO') {
                                            <div class="youtube_video">
                                              <iframe
                                                width="345"
                                                class="iframe-youtube"
                                                allowfullscreen=""
                                                height="194"
                                                [attr.src]="item?.url | safe : 'resourceUrl'"
                                                >
                                              </iframe>
                                            </div>
                                          }
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    } @else {
                      @for (category of contentItemList$; track category) {
                        <div>
                          <h2 class="category-name">{{ category?.name }}</h2>
                          <div class="accordions">
                            @for (item of category?.contentItems; track item; let i = $index) {
                              <div
                                class="accordion"
                                [ngClass]="{ selected: item.selected }"
                                >
                                @if (category.selected === true) {
                                  <div>
                                    <div class="accordion-header" (click)="toggleAccordion(item)">
                                      <h3 class="accordion-title">{{ item.title }}</h3>
                                      <span class="accordion-icon">{{
                                        item.selected ? "-" : "+"
                                      }}</span>
                                    </div>
                                    @if (item.selected) {
                                      <div class="accordion-content">
                                        <div class="content-data" [innerHTML]="item.content"></div>
                                        @for (item of item.contentDocuments; track item; let i = $index) {
                                          <div
                                            >
                                            <div>
                                              @if (item.type == 'PAGE_LINK') {
                                                <a
                                                  href="{{ item.url }}"
                                                  target="_blank"
                                                  class="linkText"
                                                  >{{ item.linkText }}</a
                                                  >
                                                }
                                              </div>
                                            </div>
                                          }
                                          @if (showHeading(item?.contentDocuments)) {
                                            <h1>
                                              <p class="resources-text">Resources</p>
                                            </h1>
                                          }
                                          @for (item of item.contentDocuments; track item; let i = $index) {
                                            <div
                                              >
                                              @if (
                                                item.type == 'YOUTUBE_VIDEO' || item.type == 'VIDEO'
                                                ) {
                                                <p
                                                  class="resources-text"
                                                  >
                                                  {{ item.linkText }}
                                                </p>
                                              }
                                              <div>
                                                @if (item.type == 'PDF') {
                                                  <div
                                                    class="document-info d-flex flex-wrap justify-content-between"
                                                    >
                                                    @if (item.type == 'PDF') {
                                                      <a
                                                        href="{{ item.url }}"
                                                        target="_blank"
                                                        class="linkText"
                                                        >{{ item.linkText }}</a
                                                        >
                                                      }
                                                      <a
                                                        href="{{ item.url }}"
                                                        class="viewAllText"
                                                        target="_blank"
                                                        >View
                                                        <img
                                                          src="/icons/viewIconNew.svg"
                                                          width="15"
                                                          height="20"
                                                        /></a>
                                                      </div>
                                                    }
                                                  </div>
                                                  @if (item.type == 'YOUTUBE_VIDEO') {
                                                    <div
                                                      class="youtube_video"
                                                      >
                                                    <iframe
                                                      width="345"
                                                      class="iframe-youtube"
                                                      allowfullscreen=""
                                                      height="194"
                                                      [attr.src]="item?.url | safe : 'resourceUrl'"
                                                      >
                                                    </iframe>
                                                  </div>
                                                }
                                                @if (item.type == 'VIDEO') {
                                                  <div class="youtube_video">
                                                    <iframe
                                                      width="345"
                                                      class="iframe-youtube"
                                                      allowfullscreen=""
                                                      height="194"
                                                      [attr.src]="item?.url | safe : 'resourceUrl'"
                                                      >
                                                    </iframe>
                                                  </div>
                                                }
                                              </div>
                                            }
                                          </div>
                                        }
                                      </div>
                                    } @else {
                                      @if (i < 3) {
                                        <div
                                          class="accordion-header"
                                          (click)="toggleAccordion(item)"
                                          >
                                          <h3 class="accordion-title">{{ item?.title }}</h3>
                                          <span class="accordion-icon">{{
                                            item.selected ? "-" : "+"
                                          }}</span>
                                        </div>
                                      }
                                      @if (i < 3) {
                                        <div>
                                          @if (item?.selected) {
                                            <div class="accordion-content">
                                              <div class="content-data" [innerHTML]="item?.content"></div>
                                              @for (item of item?.contentDocuments; track item; let i = $index) {
                                                <div
                                                  >
                                                  <div>
                                                    @if (item.type == 'PAGE_LINK') {
                                                      <a
                                                        href="{{ item.url }}"
                                                        target="_blank"
                                                        class="linkText"
                                                        >{{ item.linkText }}</a
                                                        >
                                                      }
                                                    </div>
                                                  </div>
                                                }
                                                @if (showHeading(item?.contentDocuments)) {
                                                  <h1>
                                                    <p class="resources-text">Resources</p>
                                                  </h1>
                                                }
                                                @for (item of item?.contentDocuments; track item; let i = $index) {
                                                  <div
                                                    >
                                                    @if (
                                                      item?.type == 'PDF' ||
                                                      item?.type == 'YOUTUBE_VIDEO' ||
                                                      item?.type == 'VIDEO'
                                                      ) {
                                                      <h1
                                                        >
                                                        @if (
                                                          item?.type == 'YOUTUBE_VIDEO' ||
                                                          item?.type == 'VIDEO'
                                                          ) {
                                                          <p
                                                            class="resources-text"
                                                            >
                                                            {{ item.linkText }}
                                                          </p>
                                                        }
                                                      </h1>
                                                    }
                                                    <div>
                                                      @if (item?.type == 'PDF') {
                                                        <div
                                                          class="document-info d-flex flex-wrap justify-content-between"
                                                          >
                                                          @if (item?.type == 'PDF') {
                                                            <a
                                                              href="{{ item?.url }}"
                                                              target="_blank"
                                                              class="linkText"
                                                              >{{ item.linkText }}</a
                                                              >
                                                            }
                                                            <a
                                                              href="{{ item.url }}"
                                                              class="viewAllText"
                                                              target="_blank"
                                                              >View
                                                              <img
                                                                src="/icons/viewIconNew.svg"
                                                                width="15"
                                                                height="20"
                                                              /></a>
                                                            </div>
                                                          }
                                                        </div>
                                                        @if (item.type == 'YOUTUBE_VIDEO') {
                                                          <div
                                                            class="youtube_video"
                                                            >
                                                          <iframe
                                                            width="345"
                                                            class="iframe-youtube"
                                                            allowfullscreen=""
                                                            height="194"
                                                            [attr.src]="item?.url | safe : 'resourceUrl'"
                                                            >
                                                          </iframe>
                                                        </div>
                                                      }
                                                      @if (item.type == 'VIDEO') {
                                                        <div class="youtube_video">
                                                          <iframe
                                                            width="345"
                                                            class="iframe-youtube"
                                                            allowfullscreen=""
                                                            height="194"
                                                            [attr.src]="item?.url | safe : 'resourceUrl'"
                                                            >
                                                          </iframe>
                                                        </div>
                                                      }
                                                    </div>
                                                  }
                                                </div>
                                              }
                                            </div>
                                          }
                                          @if (i == 5) {
                                            <div class="view-all-section">
                                              <a
                                                class="view-all-content"
                                                [routerLink]="['/help-center/' + category.code]"
                                                (click)="showCategoryAccordion()"
                                                >View more</a
                                                >
                                              </div>
                                            }
                                          }
                                        </div>
                                      }
                                    </div>
                                  </div>
                                }
                              }
                            </div>
                          }
                        </div>
                      </section>
